import React from 'react'

const Outer = ({children}) => {
  return (
    <div className="flex md:justify-center  mb-24">{children}</div>
  )
}

export default Outer